import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { IFileDownload } from 'src/app/interface/dto';

@Component({
  selector: 'app-file-download',
  templateUrl: './file-download.component.html',
  styleUrls: ['./file-download.component.scss']
})
export class FileDownloadComponent implements OnInit {
  @Input() exportedFile: IFileDownload = {
    fileName: '',
    size: 0,
    extension: '',
    file: undefined
  };
  @ViewChild('downloadBtn') downloadBtn: ElementRef;

  constructor(private popoverRef: PopoverRef<FileDownloadComponent>, private sanitizer: DomSanitizer,) { }

  ngOnInit() {

  }

  ngAfterViewInit() {
    if (this.exportedFile) {
      let inputElement: HTMLElement = this.downloadBtn.nativeElement as HTMLElement;
      inputElement.click();
      this.popoverRef.close();
    }
  }

  close() {
    this.popoverRef.close();
  }

  sanitizeUrl(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }
}
